import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  return <section id="pricing" className="py-24 px-4 bg-brand-bgDark relative" data-id="element-117">
      <div className="max-w-5xl mx-auto relative z-10 flex flex-col items-center" data-id="element-118">
        {/* Urgency Header */}
        <div className="text-center mb-16 w-full" data-id="element-119">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-block bg-red-500/20 border border-red-500/30 text-red-300 font-poppins font-bold px-6 py-2 rounded-full text-sm md:text-base mb-8 uppercase tracking-widest" data-id="element-120">
            ⏰ OFERTA DE LANZAMIENTO
          </motion.div>

          <h2 className="text-3xl md:text-4xl font-poppins font-bold text-white mb-4" data-id="element-121">
            Termina en pocas horas
          </h2>

          <CountdownTimer data-id="element-122" />

          <p className="text-green-200 font-medium text-lg mt-4" data-id="element-123">
            🔥 Precio sube después
          </p>
        </div>

        <h3 className="text-4xl md:text-5xl font-poppins font-black text-center text-white mb-16" data-id="element-124">
          🥗 ELEGÍ TU PACK
        </h3>

        <div className="flex flex-col md:flex-row justify-center items-stretch gap-6 w-full" data-id="element-125">
          {/* Card 1: Basic */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex-1 bg-white border border-green-200 rounded-3xl p-8 md:p-10 flex flex-col text-center shadow-xl" data-id="element-126">
            <div className="mb-8" data-id="element-127">
              <h4 className="text-2xl font-poppins font-bold text-brand-text mb-2" data-id="element-128">
                📘 PACK COMPLETO
              </h4>
              <p className="text-gray-500 font-medium" data-id="element-129">6 tomos + 4 bonus</p>
            </div>

            <div className="mb-10 flex-1" data-id="element-130">
              <p className="text-gray-400 line-through text-xl font-medium mb-2" data-id="element-131">
                $49.990
              </p>
              <p className="text-4xl md:text-5xl font-poppins font-black text-green-600" data-id="element-132">
                $19.990
              </p>
            </div>

            <CTAButton href="https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNAAESb8Iq0IXsooK6vfgqw/es-ar?_r=AQAB7YbSt_vXv-PHoxKv-f4r9H_OU0k9q8bGpNQTZrdXCDo" className="w-full text-base md:text-lg py-4 px-6" data-id="element-133">
              👉 QUIERO BAJAR DE PESO
            </CTAButton>
          </motion.div>

          {/* Card 2: Pro (Recommended) */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="flex-1 bg-white border-2 border-green-400 rounded-3xl p-8 md:p-10 flex flex-col relative shadow-[0_0_40px_rgba(34,197,94,0.3)] md:-mt-4 md:mb-4 z-10 text-center" data-id="element-134">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 bg-green-500 text-white font-poppins font-bold px-6 py-1.5 rounded-b-xl text-xs uppercase tracking-widest shadow-md" data-id="element-135">
              RECOMENDADO
            </div>

            <div className="mb-8 mt-4" data-id="element-136">
              <h4 className="text-3xl font-poppins font-black text-brand-text mb-3" data-id="element-137">
                🏆 PACK + PLAN PRO
              </h4>
              <p className="text-brand-accent font-medium text-sm md:text-base" data-id="element-138">
                Incluye TODO + guía avanzada:
              </p>
            </div>

            <ul className="space-y-4 mb-10 flex-1 text-left max-w-xs mx-auto" data-id="element-139">
              {['Menú semanal armado', 'Organización completa', 'Estrategia para sostener resultados y TEST'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-140">
                  <CheckIcon className="w-5 h-5 text-brand-accent flex-shrink-0 mt-0.5" data-id="element-141" />
                  <span className="text-gray-700 font-medium text-base" data-id="element-142">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="mb-10 text-center" data-id="element-143">
              <p className="text-gray-400 line-through text-xl font-medium mb-2" data-id="element-144">
                $59.990
              </p>
              <p className="text-4xl md:text-5xl font-poppins font-black text-green-600 drop-shadow-[0_0_15px_rgba(34,197,94,0.2)]" data-id="element-145">
                🔥 $27.990
              </p>
            </div>

            <CTAButton href="https://salud-en-tu-plato.myshopify.com/cart/48180907081895:1" className="w-full text-base md:text-lg py-5 px-6" data-id="element-146">
              👉 QUIERO EL PLAN COMPLETO
            </CTAButton>
          </motion.div>
        </div>
      </div>
    </section>;
}